import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"height":"100%"},
  align: "Center"
}
const _hoisted_2 = { id: "overall-body" }
const _hoisted_3 = {
  id: "body-container",
  align: "left"
}
const _hoisted_4 = {
  id: "body-table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_5 = { id: "main-container" }
const _hoisted_6 = {
  width: "100%",
  cellspacing: "5",
  cellpadding: "0",
  border: "0"
}
const _hoisted_7 = { valign: "top" }
const _hoisted_8 = {
  valign: "top",
  align: "left"
}
const _hoisted_9 = { class: "full-width" }
const _hoisted_10 = { style: {"border":"1px solid black","margin":"0 2rem"} }
const _hoisted_11 = {
  width: "100%",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_12 = { class: "btm-border" }
const _hoisted_13 = { class: "btm-border" }
const _hoisted_14 = { class: "btm-border" }
const _hoisted_15 = { class: "btm-border" }
const _hoisted_16 = { style: {"padding-left":"10px"} }
const _hoisted_17 = { style: {"width":"345px","text-align":"right"} }
const _hoisted_18 = { style: {"border":"1px solid black","margin":"0 2rem"} }
const _hoisted_19 = {
  width: "100%",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_20 = { class: "btm-border" }
const _hoisted_21 = { class: "btm-border" }
const _hoisted_22 = { class: "btm-border" }
const _hoisted_23 = { style: {"padding-left":"10px"} }
const _hoisted_24 = { style: {"border":"1px solid black","margin":"0 2rem","min-height":"150px"} }
const _hoisted_25 = {
  width: "100%",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_26 = { style: {"border":"1px solid black","margin":"0 2rem"} }
const _hoisted_27 = {
  width: "100%",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_28 = { style: {"padding":"0 10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.$store.getters.isInternalUser)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("table", _hoisted_6, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_7, [
                          _createElementVNode("td", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _cache[29] || (_cache[29] = _createElementVNode("div", { style: {"border":"1px solid black","margin":"0 2rem","text-align":"right"} }, [
                                _createElementVNode("span", { style: {"font-size":"10px"} }, [
                                  _createTextVNode(" Unit J, Building 2, 3 Ceres Court PO Box 303484, North Harbour, Auckland"),
                                  _createElementVNode("br"),
                                  _createTextVNode(" Tel. 09 4772720 Email "),
                                  _createElementVNode("a", { href: "mailto:keithf@compassnzl.co.nz" }, "keithf@compassnzl.co.nz")
                                ]),
                                _createElementVNode("br"),
                                _createElementVNode("br"),
                                _createElementVNode("div", { style: {"text-transform":"uppercase","font-weight":"bold","font-size":"18px","letter-spacing":"1px","text-align":"center"} }, " Report In Lieu Of Form 12A ")
                              ], -1)),
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("table", _hoisted_11, [
                                  _createElementVNode("tbody", null, [
                                    _cache[7] || (_cache[7] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        colspan: "2",
                                        class: "title"
                                      }, "The Building")
                                    ], -1)),
                                    _createElementVNode("tr", _hoisted_12, [
                                      _cache[0] || (_cache[0] = _createElementVNode("td", null, [
                                        _createElementVNode("strong", null, "Street address:")
                                      ], -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.propertyData.streetAddress) + " " + _toDisplayString(_ctx.propertyData.suburb) + " " + _toDisplayString(_ctx.propertyData.city), 1)
                                    ]),
                                    _createElementVNode("tr", _hoisted_13, [
                                      _cache[1] || (_cache[1] = _createElementVNode("td", null, [
                                        _createElementVNode("strong", null, "Legal Description of land where building is located:")
                                      ], -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.bwof.legalDescription), 1)
                                    ]),
                                    _createElementVNode("tr", _hoisted_14, [
                                      _cache[2] || (_cache[2] = _createElementVNode("td", null, [
                                        _createElementVNode("strong", null, "Building name / trading name:")
                                      ], -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.propertyData.buildingName), 1)
                                    ]),
                                    _createElementVNode("tr", _hoisted_15, [
                                      _cache[3] || (_cache[3] = _createElementVNode("td", null, [
                                        _createElementVNode("strong", null, "Location of Building within site/block number:")
                                      ], -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.bwof.locationOfBuildingWithinSite), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_16, [
                                        _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Level/Unit Number:", -1)),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.bwof.levelUnitNo), 1)
                                      ]),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("div", _hoisted_17, [
                                          _cache[5] || (_cache[5] = _createElementVNode("strong", null, "CS #:", -1)),
                                          _cache[6] || (_cache[6] = _createTextVNode()),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.bwof.complianceSchedule), 1)
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("table", _hoisted_19, [
                                  _createElementVNode("tbody", null, [
                                    _cache[13] || (_cache[13] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        colspan: "2",
                                        class: "title"
                                      }, "The Owner")
                                    ], -1)),
                                    _createElementVNode("tr", _hoisted_20, [
                                      _cache[8] || (_cache[8] = _createElementVNode("td", null, [
                                        _createElementVNode("strong", null, "Name of Owner:")
                                      ], -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.owner.companyName), 1)
                                    ]),
                                    _createElementVNode("tr", _hoisted_21, [
                                      _cache[9] || (_cache[9] = _createElementVNode("td", null, [
                                        _createElementVNode("strong", null, "Contact Person:")
                                      ], -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.ownerContact.firstName) + " " + _toDisplayString(_ctx.ownerContact.lastName), 1)
                                    ]),
                                    _createElementVNode("tr", _hoisted_22, [
                                      _cache[10] || (_cache[10] = _createElementVNode("td", null, [
                                        _createElementVNode("strong", null, "Mailing Address:")
                                      ], -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.owner.postalAddress) + " " + _toDisplayString(_ctx.owner.suburb) + " " + _toDisplayString(_ctx.owner.city), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_23, [
                                        _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Street address / registered office:", -1)),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.owner.streetAddress), 1)
                                      ]),
                                      _cache[12] || (_cache[12] = _createElementVNode("td", null, " ", -1))
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "title" }, " Specified System Or Feature ", -1)),
                                _createElementVNode("table", _hoisted_25, [
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleServices, (srv) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: srv.serviceId,
                                        class: "btm-border"
                                      }, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("span", null, _toDisplayString(srv.ref), 1)
                                        ]),
                                        _createElementVNode("td", null, _toDisplayString(srv.serviceName), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "title" }, " Report ", -1)),
                                _createElementVNode("table", _hoisted_27, [
                                  _createElementVNode("tbody", null, [
                                    _cache[17] || (_cache[17] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        colspan: "2",
                                        style: {"font-style":"italic","padding":"0 10px"}
                                      }, " 1) A full explanation of why the required inspection, maintenance or reporting procedures have not been carried out for the 12 months prior to the anniversary date of the Compliance Schedule and what corrective action has been undertaken to eliminate any reoccurrence. ")
                                    ], -1)),
                                    _cache[18] || (_cache[18] = _createElementVNode("tr", { class: "btm-border" }, [
                                      _createElementVNode("td", { colspan: "2" }, [
                                        _createElementVNode("div", {
                                          contenteditable: "true",
                                          class: "editable-div"
                                        }, " Owners inspections allocated to tenant to complete however this was not done despite record book being available on site. This has been discussed with tenant and an assurance has been provided that these will be completed in accordance with the Compliance Schedule ongoing. ")
                                      ])
                                    ], -1)),
                                    _cache[19] || (_cache[19] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        colspan: "2",
                                        style: {"font-style":"italic","padding":"0 10px"}
                                      }, " 2) A statement that any remedial work and/or inspection and maintenance on the specified system/ feature has been carried out and that the specified system/ feature is now in a compliant state and fully operational. ")
                                    ], -1)),
                                    _cache[20] || (_cache[20] = _createElementVNode("tr", { class: "btm-border" }, [
                                      _createElementVNode("td", { colspan: "2" }, [
                                        _createElementVNode("div", {
                                          contenteditable: "true",
                                          class: "editable-div"
                                        }, " An annual IQP inspection was completed and the system(s) were found to be otherwise in a compliant state and fully operational (see attached IQP statement). ")
                                      ])
                                    ], -1)),
                                    _cache[21] || (_cache[21] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        colspan: "2",
                                        style: {"font-style":"italic","padding":"0 10px"}
                                      }, " 3) A statement that an Independent Qualified Person/Licensed Building Practitioner has been and will continue to be engaged to inspect, maintain and report on the specified feature /system. ")
                                    ], -1)),
                                    _cache[22] || (_cache[22] = _createElementVNode("tr", { class: "btm-border" }, [
                                      _createElementVNode("td", { colspan: "2" }, [
                                        _createElementVNode("div", {
                                          contenteditable: "true",
                                          class: "editable-div"
                                        }, " The owner will ensure an IQP is contracted ongoing to inspect, maintain and report on the specified system(s)/feature(s) in accordance with the compliance schedule. The IQP is currently Compass New Zealand Ltd. ")
                                      ])
                                    ], -1)),
                                    _cache[23] || (_cache[23] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        colspan: "2",
                                        style: {"font-style":"italic","padding":"0 10px"}
                                      }, " 4) A statement that the ongoing inspection, maintenance and reporting procedures will be carried out to permit a 12A certificate to be issued for that specified system(s)/feature(s) on the next and subsequent anniversaries of the issued Compliance Schedule. ")
                                    ], -1)),
                                    _cache[24] || (_cache[24] = _createElementVNode("tr", { class: "btm-border" }, [
                                      _createElementVNode("td", { colspan: "2" }, [
                                        _createElementVNode("div", {
                                          contenteditable: "true",
                                          class: "editable-div"
                                        }, " We are confident going forward that inspection, maintenance and reporting procedures, in respect of the specified system(s)/feature(s) detailed in this report, will be complete as per the compliance schedule and a Form 12A provided in conjunction with the next building warrant of fitness. ")
                                      ])
                                    ], -1)),
                                    _cache[25] || (_cache[25] = _createElementVNode("tr", { class: "btm-border" }, [
                                      _createElementVNode("td", { colspan: "2" }, "IQP statements are attached to support assertions in item 2 and 3 of this report. IQP statement by Compass New Zealand Ltd.")
                                    ], -1)),
                                    _cache[26] || (_cache[26] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        style: {"font-style":"italic","padding":"0 10px"},
                                        width: "270px"
                                      }, [
                                        _createTextVNode("Signed by building "),
                                        _createElementVNode("span", { style: {"text-decoration":"line-through"} }, "owner"),
                                        _createTextVNode(" / owner's agent")
                                      ]),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("div", { style: {"height":"50px","font-weight":"bold","padding":"0 10px"} }, [
                                          _createElementVNode("div", {
                                            class: "document-text-border col mr-4 mt-1 css-image signature-keith",
                                            style: {"height":"30px"}
                                          }),
                                          _createTextVNode(" Keith Flatt IQP #110459 ")
                                        ])
                                      ])
                                    ], -1)),
                                    _cache[27] || (_cache[27] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        style: {"font-style":"italic","padding":"0 10px"},
                                        width: "270px"
                                      }, "Countersigned by"),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("div", { style: {"height":"50px","font-weight":"bold","padding":"0 10px"} }, [
                                          _createElementVNode("div", {
                                            class: "document-text-border col mr-4 mt-1",
                                            style: {"height":"30px"}
                                          })
                                        ])
                                      ])
                                    ], -1)),
                                    _createElementVNode("tr", null, [
                                      _cache[16] || (_cache[16] = _createElementVNode("td", { style: {"padding":"0 10px"} }, "Compass New Zealand Limited", -1)),
                                      _createElementVNode("td", _hoisted_28, [
                                        _cache[15] || (_cache[15] = _createElementVNode("strong", null, "DATE:", -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.formattedDate(_ctx.issuedDate || new Date())), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}